module.exports = __webpack_public_path__ + "img/9788971997376.33caeba0.jpg";